'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withWindow = require('../helpers/withWindow');

var _withWindow2 = _interopRequireDefault(_withWindow);

var _PromotionModal = require('./PromotionModal');

var _PromotionModal2 = _interopRequireDefault(_PromotionModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _withWindow2.default)(_PromotionModal2.default);


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PromotionModal/index.js
// module id = 316
// module chunks = 0